import { Canceler } from 'axios';
import { ImageCachePaths } from '@synergy/models';

export interface ProductFile {
    id: number;
    title: string;
    fileName: string;
    path: string;
    size: number;
    type: string;

    cancel?: Canceler;
    uploadProgress?: number;
}

export interface ProductImageFile extends ProductFile {
    isPreviewImage: boolean;
    formats?: ImageCachePaths;
}

export const isImageFile = (file: ProductImageFile | ProductFile): file is ProductImageFile =>
    (file as ProductImageFile).isPreviewImage !== undefined;
